module.exports = __webpack_public_path__ + "static/Democracy_Reform-9eca4cfece90b0fb37c1fbb380459daa.png";